var map = {
	"./additional-resources.de-CH.json": 1400,
	"./additional-resources.de-DE.json": 1401,
	"./additional-resources.en-CA.json": 1402,
	"./additional-resources.en-GB.json": 1403,
	"./additional-resources.en-IN.json": 1404,
	"./additional-resources.en-ME.json": 1405,
	"./additional-resources.en-US.json": 1406,
	"./additional-resources.es-EM.json": 1407,
	"./additional-resources.es-ES.json": 1408,
	"./additional-resources.fr-BE.json": 1409,
	"./additional-resources.fr-CA.json": 1410,
	"./additional-resources.fr-CH.json": 1411,
	"./additional-resources.nl-BE.json": 1412,
	"./additional-resources.nl-NL.json": 1413,
	"./additional-resources.pl-PL.json": 1414,
	"./additional-resources.pt-BR.json": 1415
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1399;